// Shared audio-output (speaker) device enumeration for LobbyScreen.vue and ControlBar.vue
import { DEVICE_KINDS } from '../constants/video';

export default {
  data() {
    return {
      audioOutputs: [],
    };
  },

  computed: {
    // Safari doesn't implement setSinkId, so output-device selection can't
    // actually be applied there — hide the control rather than show a picker
    // that silently does nothing.
    supportsSpeakerSelection() {
      return typeof HTMLMediaElement !== 'undefined'
        && typeof HTMLMediaElement.prototype.setSinkId === 'function'
        && this.audioOutputs.length > 0;
    },
  },

  // Keep the speaker list live if a device is plugged/unplugged while the
  // lobby or an in-call menu is open.
  mounted() {
    navigator.mediaDevices?.addEventListener?.('devicechange', this.refreshOutputDevices);
  },

  beforeUnmount() {
    navigator.mediaDevices?.removeEventListener?.('devicechange', this.refreshOutputDevices);
  },

  methods: {
    setAudioOutputsFromDevices(devices) {
      this.audioOutputs = devices
        .filter((d) => d.kind === DEVICE_KINDS.AUDIO_OUTPUT)
        .map((d) => ({ deviceId: d.deviceId, label: d.label || `Speaker ${d.deviceId.slice(0, 6)}` }));
    },

    async refreshOutputDevices() {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        this.setAudioOutputsFromDevices(devices);
      } catch (e) {
        this.audioOutputs = [];
      }
    },
  },
};
